module.exports = __webpack_public_path__ + "static/media/icon_accuracy-data-issue.aeedfa01.svg";